// Backend role is the single source of truth for the landing route.
export function roleHome(user) {
  switch (user?.role) {
    case "MASTER_ADMIN":
    case "CO_ADMIN":
      return "/admin";
    case "COACH":
      return "/coach";
    default:
      return "/dashboard";
  }
}
